import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import {
  getFakeClientUser,
  getUserRole,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { useSelector, useDispatch } from 'react-redux';
import authorizationService from '../../common/services/security/authorizationService';
import authenticationUrlBuilder from '../../common/services/security/authenticationUrlBuilder';
import locationService from '../../common/services/locationService';
import {
  getUserTermsAndConditionsLoading,
  getUserTermsAndConditionsLoaded,
  getUserTermsAndConditionsHasAccepted,
} from '../../common/redux/userTermsAndConditions/userTermsAndConditionsSlice';
import { getUserTermsAndConditionsThunk } from '../../common/redux/userTermsAndConditions/getUserTermsAndConditionsThunk';
import { PendoStarter } from '../userAnalytics/PendoStarter';

const Landing = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const routePath = '/projects';
  const tAndCPath = '/terms-and-conditions';

  const tAndCLoading = useSelector(getUserTermsAndConditionsLoading);
  const tAndCLoaded = useSelector(getUserTermsAndConditionsLoaded);
  const tAndCHasAccepted = useSelector(getUserTermsAndConditionsHasAccepted);

  const hasValidToken = authorizationService.hasValidToken();

  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const isFakeClientUser = useSelector(getFakeClientUser);

  useEffect(() => {
    if (!hasValidToken) {
      const finalRedirect = location.state
        ? location.state.from.pathname
        : routePath;

      authenticationUrlBuilder
        .build(finalRedirect)
        .then((authenticationUrl) => {
          locationService.redirect(authenticationUrl);
        });
    }
  }, [hasValidToken, location.state]);

  useEffect(() => {
    if (hasValidToken && !isPwcUser && !tAndCLoading && !tAndCLoaded) {
      dispatch(getUserTermsAndConditionsThunk(authorizationService.getEmail()));
    }
  }, [hasValidToken, tAndCLoaded, tAndCLoading, dispatch, isPwcUser]);

  if (hasValidToken) {
    if (!isPwcUser && !isFakeClientUser) {
      if (tAndCLoaded && tAndCHasAccepted) {
        const fromPath =
          location.state && location.state.from
            ? location.state.from.pathname
            : null;
        return (
          <Redirect
            to={{
              pathname: fromPath || routePath,
            }}
          />
        );
      }

      if (tAndCLoaded) {
        return <Redirect to={{ pathname: tAndCPath }} />;
      }

      return null;
    }

    return (
      <Redirect
        to={{
          pathname: routePath,
        }}
      />
    );
  }

  return null;
};

export default () => (
  <PendoStarter>
    <Landing />
  </PendoStarter>
);
